import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Language } from 'enums';
import { fetchCurrentUser, fetchCurrentUserSecurity } from 'services';

import { RootState } from './store';
import { AppState } from './types';

const initialLanguage = (localStorage.getItem('language') as Language) || Language.EN;

const initialState: AppState = {
  language: initialLanguage,
  user: null,
  permissions: 0,
  isPermissionsLoaded: false,
  archiveOpened: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    changeLanguage(state: AppState, { payload }: { payload: Language }) {
      state.language = payload;

      localStorage.setItem('language', `${state.language}`);
    },
    setArchiveOpened(state, { payload }: PayloadAction<boolean>) {
      state.archiveOpened = payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchCurrentUser.fulfilled, (state, { payload }) => {
      state.user = payload;
    });
    builder.addCase(fetchCurrentUserSecurity.fulfilled, (state, { payload }) => {
      state.permissions = payload;
      state.isPermissionsLoaded = true;
    });
  },
});

export const {
  actions: { changeLanguage, setArchiveOpened },
  reducer: appReducer,
} = appSlice;

export const getLanguage = ({ app }: RootState) => app.language;
export const getUser = ({ app }: RootState) => app.user;
export const getCurrentUserPermissions = ({ app }: RootState) => app.permissions;
export const getCurrentUserPermissionsLoaded = ({ app }: RootState) => app.isPermissionsLoaded;
export const getArchiveOpened = ({ app }: RootState) => app.archiveOpened || false;
